import GET from "./api/GET";

export const trackDrivers = async (branch) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/track-order/drivers?branchId=${branchId}`
  );
  return response;
};
export const trackDriver = async (branch, driverId) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/track-order/driver?branchId=${branchId}&driverId=${driverId}`
  );
  return response;
};
export const trackBranch = async (branch) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/track-order/branch?branchId=${branchId}`
  );
  return response;
};
export const trackCustomers = async (branch) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = branch?._id ?? JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/track-order/customers?branchId=${branchId}`
  );
  return response;
};
